import sortBy from 'lodash/sortBy'
import { useTranslation } from 'react-i18next'

import { Box, Chip, Tooltip } from '@dhl-ui/components'
import { RoleNameDto } from '@dhl/mdp-api'

type Props = {
  roles: RoleNameDto[]
}

export const RoleTags = ({ roles }: Props) => {
  const { t } = useTranslation()

  const mappedRoles = roles.map((role) => {
    return {
      role,
      title: t(`admin.roles.${role}.title`),
      tag: t(`admin.roles.${role}.tag`),
    }
  })

  return (
    <>
      {sortBy(mappedRoles, ['tag']).map(({ title, tag }, index) => (
        <Box mr={1} display="inline-block" key={index}>
          <Tooltip title={title} key={index}>
            <Chip label={tag} size="medium" />
          </Tooltip>
        </Box>
      ))}
    </>
  )
}
